'use strict';
import {ASSET_TASK_COLLECTION, TASK_COLLECTION} from '../../tasks/domain/config';

export function targetIsTask(target) {
  const collection = target && target.collection;
  switch (collection) {
    case ASSET_TASK_COLLECTION:
    case TASK_COLLECTION:
      return true;

    default:
      return false;
  }
}



// WEBPACK FOOTER //
// ./src/js/priorities/domain/utils.js